
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShiftLock as ObiShiftLockElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-shift-lock.js';
 
 
 

 
 export const ObiShiftLock = createComponent({
   react: React,
   tagName: 'obi-shift-lock',
   elementClass: ObiShiftLockElement,
   events: {
     
   }
  });
 
 